<template>
    <svg
        height="24px"
        width="24px"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        xml:space="preserve"
        style="fill: currentColor; font-width: 1.5em"
    >
        <g>
            <path
                d="M256,149.333c-58.816,0-106.667,47.851-106.667,106.667S197.184,362.667,256,362.667S362.667,314.816,362.667,256
			S314.816,149.333,256,149.333z M256,341.333c-47.061,0-85.333-38.272-85.333-85.333s38.272-85.333,85.333-85.333
			s85.333,38.272,85.333,85.333S303.061,341.333,256,341.333z"
            />
            <path
                d="M160,0H53.333C23.915,0,0,23.936,0,53.333V160c0,5.888,4.779,10.667,10.667,10.667S21.333,165.888,21.333,160V53.333
			c0-17.643,14.357-32,32-32H160c5.888,0,10.667-4.779,10.667-10.667S165.888,0,160,0z"
            />
            <path
                d="M458.667,0H352c-5.888,0-10.667,4.779-10.667,10.667S346.112,21.333,352,21.333h106.667c17.643,0,32,14.357,32,32V160
			c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667V53.333C512,23.936,488.085,0,458.667,0z"
            />
            <path
                d="M160,490.667H53.333c-17.643,0-32-14.357-32-32V352c0-5.888-4.779-10.667-10.667-10.667S0,346.112,0,352v106.667
			C0,488.064,23.915,512,53.333,512H160c5.888,0,10.667-4.779,10.667-10.667C170.667,495.445,165.888,490.667,160,490.667z"
            />
            <path
                d="M501.333,341.333c-5.888,0-10.667,4.779-10.667,10.667v106.667c0,17.643-14.357,32-32,32H352
			c-5.888,0-10.667,4.779-10.667,10.667c0,5.888,4.779,10.667,10.667,10.667h106.667C488.085,512,512,488.064,512,458.667V352
			C512,346.112,507.221,341.333,501.333,341.333z"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-zoom-in",
});
</script>
